import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import labtestService from "../../../Services/labtestservices";

const LabTestServices = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [labTests, setLabTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLabTests = async () => {
      try {
        setLoading(true);
        const response = await labtestService.fetchAll();
        setLabTests(response.services || []);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching lab tests.");
      }
    };
    fetchLabTests();
  }, []);

  useEffect(() => {
    const filtered = labTests.filter((test) =>
      test.name.toLowerCase().includes(searchData.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchData, labTests]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData.slice(startIndex, endIndex));
  }, [currentPage, filteredData]);

  return (
    <div className="p-3 sm:p-6">

      <div className="bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-4 sm:mb-5 shadow-sm">

     <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">

  <div>
    <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800 leading-tight">
      Lab Test Services
    </h1>
    <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
      {filteredData.length} records found
    </p>
  </div>

  <div className="flex items-center gap-2 w-full sm:w-auto">

    <div className="relative flex-1 sm:flex-none">
      <SearchIcon
        className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
        style={{ fontSize: 16 }}
      />
      <input
        type="search"
        placeholder="Search by name..."
        value={searchData}
        onChange={(e) => setSearchData(e.target.value)}
        className="pl-8 pr-3 py-[7px] w-full sm:w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#2F6DB4]/30"
      />
    </div>

    <button
      onClick={() => navigate("addlabtest")}
      className="flex-shrink-0 relative overflow-hidden bg-[#2F6DB4] text-white text-[12px] sm:text-[13px] font-[500] px-3 sm:px-4 py-2 rounded-lg shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"
    >
      + Lab Test
    </button>

  </div>
</div>

      
      </div>

      <div className="hidden sm:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[400px]">
            <thead>
              <tr className="bg-[#2F6DB4] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">ID</th>
                <th className="py-3 px-4 text-left">Lab Test</th>
                <th className="py-3 px-4 text-center">Price</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="py-10 text-center text-gray-400 text-[13px]">Loading...</td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td colSpan={4} className="py-10 text-center text-gray-400 text-[13px]">No records found</td>
                </tr>
              ) : (
                paginatedData.map((test) => (
                  <tr key={test.id} className="border-t hover:bg-gray-50 text-[13px]">
                    <td className="py-3 px-4 text-gray-500">{test.id}</td>
                    <td className="py-3 px-4 font-[500] text-gray-800">{test.name}</td>
                    <td className="py-3 px-4 text-center text-gray-600">{test.price}</td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => navigate(`addlabtest/${test.id}`)}
                        className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100 transition-colors"
                      >
                        Update
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="sm:hidden space-y-2.5">
        {loading ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            Loading...
          </div>
        ) : paginatedData.length === 0 ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            No records found
          </div>
        ) : (
          paginatedData.map((test) => (
            <div
              key={test.id}
              className="bg-white border border-gray-200 rounded-xl px-4 py-3.5 shadow-sm"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-[10px] font-bold text-[#2F6DB4] uppercase tracking-wide">
                  ID #{test.id}
                </span>
                <button
                  onClick={() => navigate(`addlabtest/${test.id}`)}
                  className="bg-blue-50 text-blue-600 text-[11px] font-[500] px-3 py-1 rounded-md hover:bg-blue-100 active:scale-95 transition-all"
                >
                  Update
                </button>
              </div>

              <p className="text-[14px] font-[600] text-gray-800 leading-tight truncate mb-2">
                {test.name}
              </p>

              <div className="flex items-center justify-between bg-gray-50 border border-gray-100 rounded-lg px-3 py-2">
                <span className="text-[11px] text-gray-400 uppercase tracking-wide font-[500]">Price</span>
                <span className="text-[13px] font-[700] text-gray-700">{test.price}</span>
              </div>
            </div>
          ))
        )}
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default LabTestServices;